module.exports = __webpack_public_path__ + "static/media/47@2x.4040dc66.png";